import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { SearchPageService } from '../search-page.service';
import { SearchFormType } from '../search-page-type.enum';
import { SearchParam, SearchParams, SearchParamType } from '../search-param.model';
import { includes } from 'lodash-es';
import { Moment } from 'moment';
import { JsonObject } from '@se/cp.common';
import { labelTranslationKeyToFromToLabel, labelTranslationKeyToString } from '../helpers';

export type ItemsSourceOpsCallback = (propertyName: string, params: any, data: any[]) => any[];

@Component({
    selector: 'se-search-filter',
    templateUrl: './search-filter.component.html',
    styleUrls: ['./search-filter.component.scss'],
    standalone: false
})
export class SearchFilterComponent implements AfterViewInit {
    labelTranslationKeyToString = labelTranslationKeyToString;

    labelTranslationKeyToFromToLabel = labelTranslationKeyToFromToLabel;

    searchFormType = SearchFormType; // Serve per leggere gli enumerati nell'html!

    searchParamType = SearchParamType;

    selectDataFilters: Record<string, string> = {};

    _disableSearch: boolean = false;

    // isearchpanel
    @Input()
    searchParams!: SearchParams;

    @Input()
    formType!: SearchFormType;

    @Input()
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filterChangeOps: Function = (propertyName: string, propertyValue: any, params: any, layouts: any) => {
        /* Ready to override */
    };

    @Input()
    itemSourceOps!: ItemsSourceOpsCallback;

    @Input()
    searchOnInit: boolean = false;

    @Output()
    searchRequired: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    resetFilterRequired: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    filterChanged: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    disableSearchRequired: EventEmitter<boolean> = new EventEmitter<boolean>();

    // Constructor

    constructor(private searchPageService: SearchPageService) {
    }

    ngAfterViewInit() {
        if (this.searchOnInit) {
            this.searchPageService.loadFormCollections(this.formType);
            this.searchParams.clearSearchParamsOnBack();
            this.onSearch();
        }
    }

    resetComboSelectedValue(propertyName: string, event: Event) {
        event.stopPropagation();
        this.searchParams.params[propertyName] = undefined;
    }

    getDate(value: Moment) {
        return value.toJSON();
    }

    onSearch() {
        this.searchRequired.emit();
    }

    onEnterKeyDown(e: Event) {
        e.preventDefault();
        this.onSearch();
    }

    onResetFilter() {
        this.resetFilterRequired.emit();
    }

    onFilterChange(propertyName: string) {
        const propertyValue = this.searchParams.params[propertyName];

        this.filterChangeOps(propertyName, propertyValue, this.searchParams.params, this.searchParams.layouts);
    }

    onFromToErrorChange(value: boolean) {
        if (value != this._disableSearch) {
            this._disableSearch = value;
            this.disableSearchRequired.emit(this._disableSearch);
        }
    }

    onSelectFiltering(propertyName: string, text: string) {
        this.selectDataFilters[propertyName] = text.toLocaleLowerCase();
    }

    getDataForSelect(propertyName: string) {
        let data = this.searchParams.dataItemsSource[propertyName].data ?? [];

        if (this.itemSourceOps) {
            data = this.itemSourceOps(propertyName, this.searchParams.params, data);
        }

        if (this.selectDataFilters[propertyName]) {
            const displayProperty = this.searchParams.dataItemsSource[propertyName].displayProperty ?? '';

            data = data.filter((item) => {
                const value = item[displayProperty];
                if (!value || typeof value !== 'string') return false;
                return includes(value.toLocaleLowerCase(), this.selectDataFilters[propertyName]);
            });
        }

        return data;
    }

    getDisplayProperty = (item: JsonObject, searchParam: SearchParam): string => {
        const key = searchParam.property.itemsSourceInfo?.displayProperty;
        if (!key) return '';
        const display = item[key];
        return typeof display === 'string' ? display : '';
    };

    optionTrackBy = (index: number, item: JsonObject) => {
        return item.id ?? item.guid;
    };
}
